import React from "react";
import About from "./Main/About";
import About2 from "./Main/About2";
import WhyUs from "./Main/WhyUs";
import Clients from "./Main/Clients";
import Services from "./Main/Services";
import CallToAction from "./Main/CallToAction";
import Portfolio from "./Main/Portfolio";
import Pricing from "./Main/Pricing";
import Testimonals from "./Main/Testimonals";
import Speakers from "./Main/Speakers";
import Contact from "./Main/Contact";
import Parts from "./Parts";

function Main(props) {
  return (
    <main id="main">
      <Parts />
      <About />
      <About2 />
      <WhyUs />
      <Clients />
      <Services />
      <CallToAction />
      <Portfolio />
      <Pricing />
      <Testimonals />
      <Speakers />
      <Contact />
    </main>
  );
}

export default Main;
